export default "__VITE_ASSET__DiEzV3ZV__"